import { now, addDays } from 'owa-datetime';
export function getExpiringSharingData(sharingData) {
    return sharingData.filter(function (x) { return isSharingDataExpiring(x); });
}
export function isSharingDataExpiring(sharingData) {
    return (sharingData &&
        sharingData.sharingInfo &&
        !!sharingData.sharingInfo.expirationDate &&
        !sharingData.sharingInfo.ignoreExpirationDate &&
        new Date(sharingData.sharingInfo.expirationDate) < addDays(now(), 7) &&
        new Date(sharingData.sharingInfo.expirationDate) > now());
}
//# sourceMappingURL=getExpiringSharingData.js.map